import { useMemo } from 'react';
import { LocationFeatureFlagSettingName } from '@weave/schema-gen-ts/dist/schemas/payments/messages/location_settings/location_settings.pb';
import { MixedBoolean } from '../../utils';
import { useLocationFeatureSettingsDirect, useLocationFeatureSettingValue } from '../locations';
import { useMemoizedArray } from '../use-memoized-array';

export const useLocationSurchargeState = (locationIds: string[]) => {
  const memoizedLocationIds = useMemoizedArray(locationIds);

  const {
    enabledLocations: featureSettingEnabledLocations,
    isAllEnabled,
    isLoading,
    isAnyEnabled,
    refetchAll,
  } = useLocationFeatureSettingsDirect(LocationFeatureFlagSettingName.SURCHARGING_ENABLED, {
    locationIds: memoizedLocationIds,
  });

  const queryValues = useLocationFeatureSettingValue(LocationFeatureFlagSettingName.SURCHARGING_ENABLED, {
    locationIds: memoizedLocationIds,
  });

  const percentValuesByLocationId = useMemo(() => {
    return Object.entries(queryValues).reduce((acc, [locationId, { value }]) => {
      acc[locationId] = value;
      return acc;
    }, {} as Record<string, number | undefined>);
  }, [queryValues]);

  return {
    enabled: (isAllEnabled || (isAnyEnabled ? 'mixed' : false)) as MixedBoolean,
    isAnyEnabled: isAnyEnabled,
    isLoading,
    firstPercentValue: locationIds[0] ? percentValuesByLocationId[locationIds[0]] : undefined,
    percentValuesByLocationId,
    featureSettingEnabledLocations,
    isAllEnabled,
    featureFlagEnabledLocations: memoizedLocationIds,
    refetchAll,
  };
};
